// data.js
const productu = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1507138170390-6625c5fd0115?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 1 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1658314755561-389d5660ee54?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1534368959876-26bf04f2c947?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1533560777802-046814bc297c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://plus.unsplash.com/premium_photo-1661398706538-4adf5b62d47a?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1528053549747-1faf5dd69883?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    }
    // Add more products as needed
  ];
  
  export default productu;
  